import { List } from 'immutable';
import { isEmpty, forEach, max } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { LocalStorageService, StateService, REDIRECTIONS } from '@sm360/widget-commons-general';
import { PurchaseMethods, DataOrigins, ShowroomService } from '@sm360/widget-commons-vehicle';

import * as FILTERS from 'catalog/constants/filter.js';
import * as types from 'catalog/actions/catalogActionTypes.js';
import * as CatalogFilterService from 'catalog/services/CatalogFilterService.js';
import * as ModelService from 'catalog/services/ModelService.js';

const { PurchaseMethodsActionsTypes, PurchaseMethodsActions, PaymentFrequencies } = PurchaseMethods;

/* eslint no-bitwise:0 */

function loadMakesSuccess(makes) {
    return { type: types.LOAD_MAKES_SUCCESS, makes };
}

function loadModelsSuccess(models) {
    return { type: types.LOAD_MODELS_SUCCESS, models };
}

function addDisclaimersToModels() {
    return (dispatch, getState) => {
        const { manufacturer } = getState();
        PurchaseMethods.DisclaimerAPIService.getModelsDisclaimers([...manufacturer.models]).then(
            (modelsWithDisclaimers) => {
                dispatch(loadModelsSuccess(List(modelsWithDisclaimers)));
            }
        );
    };
}

export function setCatalogFilter(catalogFilter) {
    return { type: types.SET_FILTER, catalogFilter };
}

function filterBodyStyles(bodyStylesFilterCodes) {
    StateService.addParamToCurrentState(
        REDIRECTIONS[LocaleService.getSimpleLocale()].catalog,
        'catalog',
        {
            catalog: 'catalog',
        },
        'bodyStylesFilterCodes',
        bodyStylesFilterCodes.join(',')
    );

    return { type: types.FILTER_BODY_STYLES, bodyStylesFilterCodes };
}

export function selectPurchaseMethod(purchaseMethod) {
    StateService.addParamToCurrentState(
        REDIRECTIONS[LocaleService.getSimpleLocale()].catalog,
        'catalog',
        {
            catalog: 'catalog',
        },
        'purchaseMethodOrder',
        purchaseMethod.value
    );

    return { type: PurchaseMethodsActionsTypes.SELECT_PURCHASE_METHOD, purchaseMethod };
}

export function selectPaymentFrequency(paymentFrequency) {
    StateService.addParamToCurrentState(
        REDIRECTIONS[LocaleService.getSimpleLocale()].catalog,
        'catalog',
        {
            catalog: 'catalog',
        },
        'paymentFrequency',
        paymentFrequency.value
    );

    return { type: PurchaseMethodsActionsTypes.SELECT_PAYMENT_FREQUENCY, paymentFrequency };
}

export function setTradeIn(tradeIn) {
    LocalStorageService.set('tradeIn', tradeIn);
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setTradeIn(tradeIn));
        dispatch(addDisclaimersToModels());
    };
}

export function setLien(lien) {
    LocalStorageService.set('lien', lien);
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setLien(lien));
        dispatch(addDisclaimersToModels());
    };
}

export function filterMake(make) {
    StateService.addParamToCurrentState(
        REDIRECTIONS[LocaleService.getSimpleLocale()].catalog,
        'catalog',
        {
            catalog: 'catalog',
        },
        'preferredMake',
        make.value
    );

    return { type: types.FILTER_MAKE, make };
}

export function filterModel(modelSearchString) {
    return { type: types.FILTER_MODEL, modelSearchString };
}

export function resetBodyStylesFilter(selectedBodyStyles) {
    return (dispatch, getState) => {
        const state = getState();
        const catalogFilter = CatalogFilterService.setBodyStylesFilter(state.catalogFilter, selectedBodyStyles);
        const { bodyStylesFilterCodes } = catalogFilter;

        dispatch(setCatalogFilter(catalogFilter));
        dispatch(filterBodyStyles(bodyStylesFilterCodes));
    };
}

export function translateCatalogFilter() {
    return (dispatch, getState) => {
        const state = getState();
        const catalogFilter = CatalogFilterService.translateFilters(state.catalogFilter);

        dispatch(setCatalogFilter(catalogFilter));
    };
}

export function loadMakes(makes, locale) {
    return (dispatch, getState) => {
        return ShowroomService.getModels(DataOrigins.MODELS_COLLECTION, makes, locale)
            .then((models) => {
                makes.push(FILTERS.MAKE_FILTER_ALL);
                dispatch(loadMakesSuccess(List(makes)));

                dispatch(
                    loadModelsSuccess(
                        List(
                            models.map((model) => {
                                return ModelService.resetModelFromCollectionData(model);
                            })
                        )
                    )
                );

                let state = getState();
                let modelsArray = state.manufacturer.models.toArray();
                let bestPaymentFrequency = PaymentFrequencies.MONTHLY;
                if (!isEmpty(modelsArray)) {
                    const bestPaymentFrequencies = [];
                    forEach(modelsArray, (modelArray) => {
                        bestPaymentFrequencies.push(modelArray.purchaseMethods.getFinancesBestPaymentFrequency());
                    });
                    bestPaymentFrequency = max(bestPaymentFrequencies);
                }
                dispatch(
                    selectPaymentFrequency({
                        value: bestPaymentFrequency,
                    })
                );

                dispatch(
                    selectPurchaseMethod({
                        value: state.catalogFilter.purchaseMethodOrder,
                    })
                );

                dispatch(
                    resetBodyStylesFilter(
                        state.catalogFilter.bodyStyles.filter((bodyStyle) => bodyStyle.selected).toArray()
                    )
                );

                state = getState();

                modelsArray = state.manufacturer.models.toArray();

                if (!isEmpty(modelsArray)) {
                    dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(modelsArray[0].purchaseMethods));
                }
                const preferredMake = state.catalogFilter.getPreferredMake();
                if (preferredMake) {
                    dispatch(filterMake(preferredMake));
                }

                dispatch(addDisclaimersToModels());
            })
            .catch((error) => {
                throw error;
            });
    };
}
